import { render, staticRenderFns } from "./pending-orders-container.vue?vue&type=template&id=0b242e1a&scoped=true&lang=pug"
import script from "./pending-orders-container.js?vue&type=script&lang=js&external"
export * from "./pending-orders-container.js?vue&type=script&lang=js&external"
import style0 from "./pending-orders-container.vue?vue&type=style&index=0&id=0b242e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b242e1a",
  null
  
)

export default component.exports